import { Text } from "@offstreetparking/design-system/typography";
import type { ReactNode } from "react";

export const SummaryRow = ({ label, value }: { label: string; value: ReactNode }) => (
	<div className="flex items-baseline justify-between gap-4">
		<Text size="sm" As="span">
			{label}
		</Text>
		<Text size="sm" weight="medium" As="span">
			{value}
		</Text>
	</div>
);
